<section class="w-full bg-white p-3 md:p-4 shadow">
    <h2 class="text-xl font-semibold px-1 mt-3 mb-4">Liste des directions</h2>
    <div
      class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-4"
    >
      <div class="flex flex-wrap gap-2 w-full sm:w-auto relative">
        <input
          type="text"
          [(ngModel)]="itemToSearch.nom"
          placeholder="Rechercher par nom..."
          (keyup)="getDirection()"
          class="pl-10 pr-4 py-2 rounded border w-full"
        />
        <span
          class="bi bi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        ></span>
      </div>
  
      <div
        class="flex flex-col  sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto"
      >
        <button
          type="button"
          (click)="openModal()"
          class="ml-1 bi bi-diagram-3 flex items-center justify-center gap-2 w-full sm:w-48 h-10 bg-orange-400 rounded-md text-white hover:bg-orange-500 transition-all"
        >
          <span>Ajouter une direction</span>
        </button>
      </div>
    </div>
  
    <div class="overflow-x-auto rounded-lg shadow-sm">
      <div class=" mb-28">
      <table class="min-w-full bg-white">
        <thead>
          <tr class="text-gray-600 border-b bg-gray-50">
            <th class="p-2 whitespace-nowrap text-left">
              <div class="flex items-center">
                <span><strong>N°</strong></span>
              </div>
            </th>
            <th class="p-2 whitespace-nowrap text-left">
              <div class="flex items-center">
                <span><strong>Nom</strong></span>
              </div>
            </th>
            

            <th class="p-2 whitespace-nowrap text-center">Action</th>
          </tr>
        </thead>
        <tbody class="custom-table">
          @for(item of itemsDirection; track item.id; let i = $index) {
          <tr
            class="border-b hover:bg-gray-50 transition-colors mb-6 {{ i % 2 === 0 ? 'bg-white' : 'bg-gray-100' }}"
          >
            <td class="p-2 txt">
              {{ i + 1 }}
            </td>
            <td class="p-2 txt">{{ item.nom }}</td>
           
            
            
           
            <td class="text-center py-3">
              <div class="dropdown  inline-block relative">
                <button
                  class="bg-orange-400 text-white p-2 rounded-md flex items-center justify-center gap-1 text-sm hover:bg-orange-500 transition-colors"
                  (click)="toggleDropdown(item.id)"
                >
                  <span class="hidden sm:inline">Action</span>
                  <i class="bi bi-chevron-down"></i>
                </button>
  
                <div
                  class="dropdown-menu absolute right-0 mt-2 bg-white shadow-lg rounded-md z-10 w-40"
                  [ngClass]="{ hidden: activeDropdown !== item.id }"
                >
                  <ul class="py-1">
                    <li>
                      <button
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                        (click)="openModal(item)"
                      >
                        <span class="text-yellow-500 mr-2"><i class="bi bi-pencil-fill"></i></span>
                        <span>Modifier</span>
                      </button>
                    </li>
                    <li>
                    <button
                      class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      (click)="openModalAddUser(item.id)"
                    >
                      <span class="text-yellow-500 mr-2"><i class="bi bi-plus-circle-fill create-icon"></i></span>
                      <span>Ajouter utilisateur</span>
                    </button>
                  </li>
                  <li>
                    <button
                      class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      (click)="openMembreModal(item.id)"
                    >
                      <span class="text-yellow-500 mr-2"><i class="bi bi-person"></i></span>
                      <span>Membres</span>
                    </button>
                  </li>
                    <li>
                      <button
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                        (click)="confirmDelete(item.id)"
                      >
                        <span class="text-yellow-500 mr-2"><i class="bi bi-trash-fill delete-icon"></i></span>
                        <span>Supprimer</span>
                      </button>
                    </li>

                  </ul>
                </div>
              </div>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="7" class="text-center py-10 text-gray-500">
              <div class="flex flex-col items-center justify-center">
                <i class="bi bi-inbox text-4xl mb-2"></i>
                Aucune donnée disponible
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    </div>
  
    <div
      class="mt-4 flex flex-col sm:flex-row justify-between items-center w-full p-3 rounded-lg shadow-sm bg-white"
    >
      <div class="w-full flex justify-between items-center flex-wrap gap-2">
        <div class="flex items-center">
          <mat-paginator
            [pageSizeOptions]="[5, 10, 20, 40, 80]"
            [pageIndex]="currentPage"
            [pageSize]="itemsPerPage"
            [length]="totalItems"
            (page)="pageChanged($event)"
            aria-label="Sélectionner une page"
          >
          </mat-paginator>
        </div>
        <div class="span_total_entree text-sm text-gray-600 font-medium px-4">
          Total : {{ totalItems || 0 }}
        </div>
      </div>
    </div>
  </section>
  <!-- Modal -->
@if (showModal) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div class="bg-white w-full max-w-md rounded-lg shadow-xl overflow-hidden">
      <!-- Modal Header -->
      <div class="px-6 py-4 bg-gray-100 border-b border-gray-200 flex justify-between items-center">
        <h1 class="text-xl font-semibold text-gray-800">{{ itemToSave.id ? 'Modifier' : 'Ajouter' }} une direction</h1>
        <button (click)="closeModal()" class="p-2 rounded-full hover:bg-gray-200 transition-colors text-gray-600">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
  
      <!-- Modal Body -->
      <div class="p-4 md:p-6">
        <div class="w-full">
          <div class="grid grid-cols-1 ">
            <!-- Left Column -->
            <div >
              <div class="form-group">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Nom <span class="text-red-500">*</span>
                </label>
                <input
                  [(ngModel)]="itemToSave.nom"
                  class="w-full h-11 border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400"
                  placeholder="Entrez un nom"
                />
              </div>
  
             
            </div>
  
          
          </div>
        </div>
      </div>
  
      <!-- Modal Footer -->
      <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
        <button
          (click)="closeModal()"
          class="px-6 py-2.5 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          Annuler
        </button>
        <button
          (click)="confirmSave(itemToSave)"
          class="px-6 py-2.5 rounded-md bg-orange-400 text-white hover:bg-orange-500 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-300"
        >
          {{ itemToSave.id ? 'Mettre à jour' : 'Enregistrer' }}
        </button>
      </div>
    </div>
  </div>
  }

  @if (showUserModal) {
    <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div class="bg-white w-full max-w-md rounded-lg shadow-xl overflow-hidden">
        <!-- Modal Header -->
        <div class="px-6 py-4 bg-gray-100 border-b border-gray-200 flex justify-between items-center">
          <h1 class="text-xl font-semibold text-gray-800">Ajouter un utilisateur à la direction</h1>
          <button (click)="closeUserModal()" class="p-2 rounded-full hover:bg-gray-200 transition-colors text-gray-600">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
    
        <!-- Modal Body -->
        <div class="p-4 md:p-6">
          <div class="w-full">
            <!-- Loader lors du chargement des utilisateurs -->
            <div *ngIf="loadingUsers" class="flex justify-center py-4">
              <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-orange-400"></div>
            </div>
            
            <!-- Sélection d'utilisateur -->
            <div *ngIf="!loadingUsers" class="form-group mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Utilisateur <span class="text-red-500">*</span>
              </label>
              <select 
                [(ngModel)]="selectedUserId" 
                (change)="selectUser(selectedUserId!)"
                class="w-full h-11 border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400"
              >
                <option [ngValue]="null" disabled selected>Sélectionnez un utilisateur</option>
                <option *ngFor="let user of itemsUser" [ngValue]="user.id">{{ user.nom }} {{ user.prenoms }}</option>
              </select>
            </div>
            
            <!-- Message d'erreur si pas d'utilisateurs disponibles -->
            <div *ngIf="!loadingUsers && (!itemsUser || itemsUser.length === 0)" class="text-center py-4 text-gray-500">
              <i class="bi bi-person-x text-3xl mb-2"></i>
              <p>Aucun utilisateur disponible</p>
            </div>
            
            <!-- Direction sélectionnée - Décommentez si vous souhaitez afficher la direction -->
            <!-- <div class="form-group mt-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">Direction</label>
              <div class="p-3 bg-gray-50 border rounded">
                {{ getDirectionName(selectedDirection) || 'Direction non sélectionnée' }}
              </div>
            </div> -->
          </div>
        </div>
    
        <!-- Modal Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            (click)="closeUserModal()"
            class="px-6 py-2.5 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Annuler
          </button>
          <button
            [disabled]="selectedUserId === null || isLoading"
            (click)="addUserDirection()"
            class="px-6 py-2.5 rounded-md bg-orange-400 text-white hover:bg-orange-500 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-300 disabled:bg-orange-200 disabled:cursor-not-allowed"
          >
            <span *ngIf="isLoading" class="inline-block animate-spin mr-2 h-4 w-4 border-t-2 border-b-2 border-white rounded-full"></span>
            Ajouter
          </button>
        </div>
      </div>
    </div>
  }
  @if (showModalMembre) {
    <div class="fixed inset-0 bg-black/50 flex items-center justify-center">
      <div class="bg-white w-full max-w-6xl max-h-[90vh] flex flex-col">
        <!-- Modal Header -->
        <div
          class="px-6 py-4 bg-gray-300 border-b border-gray-100 flex justify-between"
        >
          <h1 class="text-xl font-semibold text-black">Liste des membres de la direction</h1>
          <button (click)="closeModalMembre()" class="px-6 py-2.5 text-black">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
    
        <!-- Modal Body avec scroll -->
        <div class="p-6 overflow-y-auto flex-grow">
          <div class="w-full max-w-6xl">
            <div class="overflow-x-auto">
              <table class="min-w-full bg-white border">
                <thead>
                  <tr class="bg-gray-100">
                    <th class="px-4 py-2 border text-left sticky top-0 bg-gray-100">
                      N°
                    </th>
                    <th class="px-4 py-2 border text-left sticky top-0 bg-gray-100">
                      Nom
                    </th>
                    <th class="px-4 py-2 border text-left sticky top-0 bg-gray-100">
                      Prénoms
                    </th>
                    <th class="px-4 py-2 border text-left sticky top-0 bg-gray-100">
                      Email
                    </th>
                    <th class="px-4 py-2 border text-left sticky top-0 bg-gray-100">
                      Profil
                    </th>
                    <th class="px-4 py-2 border text-left sticky top-0 bg-gray-100">
                      Contact
                    </th>
                    
                  </tr>
                </thead>
                <tbody class="max-h-96">
                  @for (item of getPaginatedMembre(); track item.id; let i =
                  $index) {
                  <tr>
                    <td class="px-4 py-2 border">{{ i + 1 }}</td>
                    <td class="px-4 py-2 border">{{ item.nom || "-" }}</td>
                    <td class="px-4 py-2 border">{{ item.prenoms || "-" }}</td>
                    <td class="px-4 py-2 border">
                      {{ item.email || "-" }}
                    </td>
                    <td class="px-4 py-2 border">{{ item.profil || "-" }}</td>
    
                    <td class="px-4 py-2 border">{{ item.telephone || "-" }}</td>
                    
                  </tr>
                  } @if (!membreItems || membreItems.length === 0) {
                  <tr>
                    <td colspan="6" class="px-4 py-2 border text-center">
                      Aucun membre disponible
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              <div
                class="mt-2 flex flex-col sm:flex-row justify-between items-center w-full p-3 rounded-lg shadow-sm"
              >
                <div class="mt-2 flex justify-end items-center w-full">
                  <!-- Le paginator et le total sont maintenant dans la même div et alignés à droite -->
                  <div class="flex justify-end items-center">
                    <mat-paginator
                      [pageSizeOptions]="[5, 10, 20, 40, 80]"
                      [pageIndex]="currentPageMembre"
                      [pageSize]="itemsPerPageMembre"
                      [length]="totalMembre"
                      (page)="pageChangedMembre($event)"
                    >
                    </mat-paginator>
    
                    <!-- Total à droite du paginator -->
                    <span class="span_total_entree ml-4"
                      >Total : {{ totalMembre || 0 }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <!-- Modal Footer -->
        <div class="px-6 py-4 border-t border-gray-100 flex justify-end gap-3">
          <button
            (click)="closeModalMembre()"
            class="px-6 py-2 bg-black text-white rounded-md hover:bg-orange-500 h-[54] w-[115]"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
    }